import React, { useEffect, useState } from 'react';
import { Button, Alert, Box } from '@mui/material';
import { usePublishMutation } from '../../store/docApi';
import { CloudUpload } from '@mui/icons-material';

const PublishItem = ({ item }) => {
  const [publish, result] = usePublishMutation();
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    if (result.isSuccess) {
      setShowMessage(true);
      // Hide message after 5 seconds
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    }
  }, [result, item.name]);

  const onPublish = async () => {
    await publish({ label: item.label, pk: item.pk, id: item.id });
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="outlined" onClick={onPublish} startIcon={<CloudUpload />}>
          Publish
        </Button>
      </Box>
      {showMessage && (
        <Alert severity="success" sx={{ mt: 1 }}>
          Published {item.name} to the store
        </Alert>
      )}
    </Box>
  );
};

export default PublishItem;
